import type { ReactNode } from "react";

import * as styles from "./ModalFooter.styles";

interface Props {
  /**
   * Optionally add a drop shadow to the top the footer
   *
   * @default false
   */
  hasShadow?: boolean;
  /**
   * Content to render within the modal footer
   *
   * @default undefined
   */
  children?: ReactNode;
}

const ModalFooter = ({ children, hasShadow, ...rest }: Props) => {
  const getStyles = [styles.ModalFooter, hasShadow && styles.FooterShadow];

  return (
    <div css={getStyles} {...rest}>
      {children}
    </div>
  );
};

export { ModalFooter };
